import { render, staticRenderFns } from "./RestockDetailIframe.vue?vue&type=template&id=41150f6a&"
import script from "./RestockDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./RestockDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports